/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Office_Provision_Defaults_HintInputs */

const cs_settings_office_provision_defaults_hint = /** @type {(inputs: Settings_Office_Provision_Defaults_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Použije se u nových obchodů, pokud nevyplníte částku ani %. U pronájmu je základem 12 × měsíční nájem.`)
};

const en_settings_office_provision_defaults_hint = /** @type {(inputs: Settings_Office_Provision_Defaults_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applied on new deals when commission amount and % are left blank. Rent uses 12 × monthly rent as the basis.`)
};

/**
* | output |
* | --- |
* | "Applied on new deals when commission amount and % are left blank. Rent uses 12 × monthly rent as the basis." |
*
* @param {Settings_Office_Provision_Defaults_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_office_provision_defaults_hint = /** @type {((inputs?: Settings_Office_Provision_Defaults_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Office_Provision_Defaults_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_office_provision_defaults_hint(inputs)
	return cs_settings_office_provision_defaults_hint(inputs)
});